import { render, staticRenderFns } from "./staffView.vue?vue&type=template&id=1c43ec15&scoped=true"
import script from "./staffView.vue?vue&type=script&lang=js"
export * from "./staffView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43ec15",
  null
  
)

export default component.exports